import { type } from 'type-r'

export function parseDOB(val) {
    if (typeof val == 'string') {
        return val;
    }
    else if(val) 
        return val.toString()
}
export function checkDOB(val) {
    if (!val) return true;
    // Strict mm/dd/yyyy regex
    const regex = /^(\d{4}).(\d{2}).(\d{2})$/
    if (!regex.test(val)) 
        return false; // 'Date must be in YYYY/DD/MM format'
    const [_, year, month, day] = val.match(regex)!
    const monthNum = parseInt(month, 10)
    const dayNum = parseInt(day, 10)
    const yearNum = parseInt(year, 10)

    // Basic range checks
    if (monthNum < 1 || monthNum > 12) return false; // 'Invalid month'
    if (dayNum < 1 || dayNum > 31) return false; // 'Invalid day'
    if (yearNum < 1900 || yearNum > new Date().getFullYear()) return false; // 'Invalid year'

    // Final real date check using JavaScript Date (careful with timezones!)
    const date = new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T12:00:00`)
    if (
      date.getFullYear() !== yearNum ||
      date.getMonth() + 1 !== monthNum ||  // getMonth() is 0-based
      date.getDate() !== dayNum
    ) {
      return false; // 'Invalid date (e.g. 02/30/2023 is not real)'
    }
    return true;
}
var DOB = type(String).parse(parseDOB).check(checkDOB, 'Invalid date');
export default DOB;
